import { render, staticRenderFns } from "./request-upload.vue?vue&type=template&id=7bd3f870&scoped=true&"
import script from "./request-upload.ts?vue&type=script&lang=ts&"
export * from "./request-upload.ts?vue&type=script&lang=ts&"
import style0 from "./request-upload.scss?vue&type=style&index=0&id=7bd3f870&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd3f870",
  null
  
)

export default component.exports